export enum AreaSpot {
  DESK = "desk",
  MEETING_ROOM = "meeting room",
  PARKING_SPOT = "parking spot",
  OTHER = "item",
}
